import styled from 'styled-components'
import fonts from '../../tokens/fonts'
import colors from '../../tokens/colors'
import border from '../../tokens/border'
import padding from '../../tokens/layout/padding'
import margin from '../../tokens/layout/margin'
import fontStyle from '../../tokens/typography'
import fontWeight from '../../tokens/typography/fontWeight'

interface CategoryProps {
  brandColor: string
}

interface ButtonProps {
  brandColorPure: string
  brandColorMedium: string
  brandColorDark: string
}

interface SlideProps {
  brandColor: string
  img: string
}

export const SlideContainer = styled.div<SlideProps>`
  background-image: url(${(props) => props.img});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: ${(props) => props.brandColor};
  font-family: ${fonts.inter};
  padding: ${padding.spacingInsetSm};
  display: grid;
  grid-template-columns: 2fr 1fr;
  border: solid ${border.width.widthHairline} ${colors.neutralColorLowLight};
  border-radius: ${border.radius.radiusSm};
`
export const SlideContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const Category = styled.span<CategoryProps>`
  color: ${(props) => props.brandColor};
  font-size: ${fontStyle.fontSize.fontSizeXxxs};
  text-transform: uppercase;
  padding-bottom: ${padding.spacingInsetNano};
`

export const Title = styled.span`
  color: ${colors.neutralColorLowPure};
  font-weight: ${fontWeight.fontWeightSemiBold};
  font-size: ${fontStyle.fontSize.fontSizeSm};
  padding-bottom: ${padding.spacingInsetSm};
`

export const Description = styled.span`
  color: ${colors.neutralColorLowPure};
  font-size: ${fontStyle.fontSize.fontSizeXs};
  font-weight: ${fontWeight.fontWeightRegular};
  padding-bottom: ${padding.spacingInsetSm};
`

export const Button = styled.a.attrs(() => ({
  target: '_blank',
  rel: 'noopener noreferrer',
}))<ButtonProps>`
  background-color: ${(props) => props.brandColorPure};
  color: ${colors.neutralColorHighPure};
  font-size: ${fontStyle.fontSize.fontSizeXxs};
  font-style: normal;
  font-weight: ${fontWeight.fontWeightSemiBold};
  border-radius: ${border.radius.radiusSm};
  border-width: ${border.width.widthNone};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: normal;
  text-transform: none;
  text-decoration: none;
  width: 10.6rem;
  height: 3.8rem;

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: ${(props) => props.brandColorMedium};
  }

  &:active {
    background-color: ${(props) => props.brandColorDark};
  }

  &:disabled {
    background-color: ${colors.neutralColorHighPure};
    color: ${colors.neutralColorLowMedium};
  }
`

export const styles = {
  indicatorContainer: {
    style: {
      position: 'absolute',
      zIndex: '100',
      top: '0',
      right: '2.4rem',
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      margin: `${margin.spacingNone}`,
      paddingTop: `${padding.spacingInsetSm}`,
    } as React.CSSProperties,
  },
  indicatorIcon: (brandColor: string) => ({
    style: {
      color: 'transparent',
      border: `solid ${border.width.widthHairline} ${brandColor}`,
      padding: `${padding.spacingInsetNone}`,
      margin: `${margin.spacingNone} ${margin.spacingQuarck}`,
      height: '1rem',
      width: '1rem',
    },
  }),
  activeIndicatorIcon: (brandColor: string) => ({
    style: {
      color: `${brandColor}`,
      border: `solid ${border.width.widthHairline} ${brandColor}`,
      height: '1rem',
      width: '1rem',
      padding: `${padding.spacingInsetNone}`,
      margin: `${margin.spacingNone} ${margin.spacingQuarck}`,
    },
  }),
}
